export default __webpack_public_path__ + "static/pragicts-itops-patch-management-c1cf7ca0ccdd49ba1dd4c7d272cd554f.jpg";